export const TOOLBAR_HEIGHT = {
    sm: 56,
    md: 64,
    lg: 80,
} as const;
